import { useNavigate } from 'react-router-dom';
import {
  InventoryManagementModules,
  InvoiceManagementModules,
  SystemAdminInvoiceManagementModules,
  NetworkMonitoringModules,
  NetworkPlanningModules,
  RegularModules,
  ApprovalPersonsInvoiceManagementModules,
  ApprovalPersonsSystemInvoiceManagementModules,
  VendorInvoiceManagementModules,
  SystemVendorInvoiceManagementModules,
  InvoiceApproverAssignmentsModules,
  SystemInvoiceApproverAssignmentsModules,
  LoginLockoutModules,
} from './components';

export const AllModulesOnLandingPage = () => {
  const navigate = useNavigate();

  const permissionsJSON = localStorage.getItem('permissions');
  let permissions = [];
  try {
    permissions = JSON.parse(permissionsJSON) || [];
  } catch (error) {
    console.error('Failed to parse permissions:', error);
  }
  const permissionNames = Array.isArray(permissions)
    ? permissions.map((permission) => permission.name)
    : [];

  const invoicePermissionCount = [
    'Admin Invoice Management',
    'Vendor Invoice Management',
    'Approval Persons Invoice Management',
    'System Invoice Management Vendor',
  ].filter((p) => permissionNames?.includes(p)).length;

  const handleNavigation = (item) => {
    if (item === 'User Management') {
      navigate('/userManagement');
    }
    if (item === 'Login Lockout') {
      navigate('/loginLockoutManagement');
    }
    if (item === 'Business Intelligence') {
      navigate('/routePlanning');
    }
    if (item === 'ranDb') {
      navigate('/oko/randb');
    }
    if (item === 'Partner Network') {
      navigate('/kmzMap');
    }
    if (item === 'KMZ') {
      navigate('/networkPlanning/kmzPlanning');
    }
    if (item === 'Ring Planning') {
      navigate('/networkPlanning/ringPlanning');
    }
    if (item === 'Fiber Pop List') {
      navigate('/networkPlanning/fiberPopList');
    }
    if (item === 'Inventory') {
      navigate('/inventory');
    }
    if (item === 'fiberSite') {
      navigate('/oko/fiberSite');
    }
    if (item === 'Leased Fiber Pair') {
      navigate('/leasedFiber');
    }
    if (item === 'Network Layer Visualization') {
      navigate('/networkLayer');
    }
    // Network Monitoring sub-modules
    if (item === 'FTTS' || item === 'MPBN' || item === 'OTN' || item === 'IPRAN') {
      sessionStorage.setItem('selectedTab', item.toLowerCase());
      navigate('/fibers');
    }
    if (item === 'Purchase Order Management') {
      navigate('/purchaseOrderManagement');
    }
    if (item === 'System Purchase Order Management') {
      navigate('/systemPurchaseOrderManagement');
    }
    if (item === 'PO Workflow Management') {
      navigate('/poWorkflowManagement');
    }
    if (item === 'System PO Workflow Management') {
      navigate('/systemPoWorkflowManagement');
    }
    if (item === 'Approval Persons Invoice Management') {
      navigate('/approvalPersonsInvoiceManagement');
    }
    if (
      item === 'Approval Persons System Invoice Management' ||
      item === 'System Approval Persons Invoice Management'
    ) {
      navigate('/approvalPersonsSystemInvoiceManagement');
    }
    if (item === 'Vendor Invoice Management') {
      navigate('/vendorInvoiceManagement');
    }
    if (item === 'System Invoice Management Vendor') {
      navigate('/systemInvoiceManagementVendor');
    }
    if (item === 'Jazz Support') {
      navigate('/jazzSupport');
    }
    if (item === 'Invoice Approver Assignments') {
      navigate('/invoiceApproverAssignments');
    }
    if (item === 'System Invoice Approver Assignments') {
      navigate('/systemInvoiceApproverAssignments');
    }
  };

  return (
    <>
      {/* Render Network Monitoring as collapsible section */}
      <NetworkMonitoringModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
      />

      {/* Render Network Planning as collapsible section */}
      <NetworkPlanningModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
      />

      {/* Render non-inventory modules */}
      <RegularModules permissionNames={permissionNames} handleNavigation={handleNavigation} />

      <LoginLockoutModules permissionNames={permissionNames} handleNavigation={handleNavigation} />

      {/* Render Invoice Management as collapsible section */}
      <InvoiceManagementModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
        invoicePermissionCount={invoicePermissionCount}
      />

      <InvoiceApproverAssignmentsModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
      />

      <SystemInvoiceApproverAssignmentsModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
      />

      {/* Render System Admin Invoice Management as separate section */}
      <SystemAdminInvoiceManagementModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
      />

      {/* Render Approval Persons Invoice Management */}
      <ApprovalPersonsInvoiceManagementModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
        invoicePermissionCount={invoicePermissionCount}
      />

      <ApprovalPersonsSystemInvoiceManagementModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
        invoicePermissionCount={invoicePermissionCount}
      />

      {/* Render Vendor Invoice Management */}
      <VendorInvoiceManagementModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
        invoicePermissionCount={invoicePermissionCount}
      />

      {/* Render System Vendor Invoice Management */}
      <SystemVendorInvoiceManagementModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
        invoicePermissionCount={invoicePermissionCount}
      />

      {/* Render Inventory Management as collapsible section */}
      <InventoryManagementModules
        permissionNames={permissionNames}
        handleNavigation={handleNavigation}
      />
    </>
  );
};
